import React from 'react';
import Highcharts from 'highcharts';

/**
 * * Catégorie 0 le type pie
 * **/
export const scriptNoTempPieCharts = (data) => {

    Highcharts.SVGRenderer.prototype.symbols.download = function (x, y, w, h) {
        var path = [
            // Arrow stem
            'M', x + w * 0.5, y,
            'L', x + w * 0.5, y + h * 0.7,
            // Arrow head
            'M', x + w * 0.3, y + h * 0.5,
            'L', x + w * 0.5, y + h * 0.7,
            'L', x + w * 0.7, y + h * 0.5,
            // Box
            'M', x, y + h * 0.9,
            'L', x, y + h,
            'L', x + w, y + h,
            'L', x + w, y + h * 0.9
        ];
        return path;
    };

    let chartParam = {
        chart: {
            backgroundColor: '#FFFFFF',
            reflow: true,
        },
        title: {
            text: ' '
        },
        legend: {
                itemStyle: {
                    color: '#000000',
                    fontWeight:"600", 
                    fontFamily:'"Source Sans Pro",sans-serif'
                },
            labelFormatter: function () {
                return this.name.slice(0, 40)
            }
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        tooltip: {
            //pointFormat: '<b>{point.name} </b>: {point.percentage:.1f}%',
            formatter: function () {
                let s;
                s = '<b>' + this.series.name.slice(0, 40) + '</b><br/>' +
                    this.key + ' : ' + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.y * 100) / 100) + ' ' + data["yAxisTitle"];
                return s;
            },
            backgroundColor: {
                linearGradient: [0, 0, 0, 60],
                stops: [
                    [0, '#FFFFFF'],
                    [1, '#E0E0E0']
                ]
            },
            borderWidth: 1,
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '{point.percentage:.1f} %',
                    color: '#000000',
                    connectorColor: '#000000',

                },
                showInLegend: true,
                animation: true
            }
        },
        exporting: {
            enabled: false,
            buttons: {
                contextButton: {
                    symbol: 'download',
                    menuItems:["viewFullscreen","separator","downloadCSV","downloadXLS","downloadJPEG"]
                }
            },
            sourceHeight: 720,
            sourceWidth: 1280,
            filename: 'export'
        },
        series: [],
        credits: {enabled: false},
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                // Make the labels less space demanding on mobile
                chartOptions: {
                    xAxis: {
                        labels: {
                            formatter: function () {
                                return this.value.charAt(0);
                            }
                        }
                    },
                    yAxis: {
                        labels: {
                            align: 'left',
                            x: 0,
                            y: -2
                        },
                        title: {
                            text: ''
                        }
                    }
                }
            }]
        }

    };

    for (let i = 0; typeof data["test" + i] != 'undefined'; i++) {
        chartParam.series.push(data["test" + i][0]);
    }
    console.log(chartParam);
    return chartParam;
}
/**
 * * Catégorie 0 le type gauge
 * **/
export const scriptNoTempGaugeCharts = (data) => {
    let chartParam = {
        chart: {
            //backgroundColor: 'Transparent',
            backgroundColor: '#FFFFFF',
            type: 'gauge',
            plotBackgroundColor: null,
            plotBackgroundImage: null,
            plotBorderWidth: 0,
            plotShadow: false
        },
        title: {
            text: ' '
        },
        pane: {
            startAngle: -150,
            endAngle: 150,
            background: [{
                backgroundColor: {
                    linearGradient: {x1: 0, y1: 0, x2: 0, y2: 1},
                    stops: [
                        [0, '#FFF'],
                        [1, '#333']
                    ]
                },
                borderWidth: 0,
                outerRadius: '109%'
            }, {
                backgroundColor: {
                    linearGradient: {x1: 0, y1: 0, x2: 0, y2: 1},
                    stops: [
                        [0, '#333'],
                        [1, '#FFF']
                    ]
                },
                borderWidth: 1,
                outerRadius: '107%'
            }, {
                // default background
            }, {
                backgroundColor: '#DDD',
                borderWidth: 0,
                outerRadius: '105%',
                innerRadius: '103%'
            }]
        },
        exporting: {
            enabled: false,
            buttons: {
                contextButton: {
                    menuItems:["viewFullscreen","separator","downloadCSV","downloadXLS","downloadJPEG"]
                }
            },
            sourceHeight: 720,
            sourceWidth: 1280,
            filename: 'export'
        },
        legend: {
                itemStyle: {
                    color: '#000000',
                    fontWeight:"600", 
                    fontFamily:'"Source Sans Pro",sans-serif'
                },
            labelFormatter: function () {
                return this.name.slice(0, 40)
            }
        },
        plotOptions: {
            gauge: {
                dataLabels: {
                    enabled: false
                },
                showInLegend: true,
                animation: true
            }
        },
        yAxis: {
            min: data["yAxisMin"],
            max: data["yAxisMax"],

            minorTickInterval: 'auto',
            minorTickWidth: 1,
            minorTickLength: 10,
            minorTickPosition: 'inside',
            minorTickColor: '#666',

            tickPixelInterval: 30,
            tickWidth: 2,
            tickPosition: 'inside',
            tickLength: 10,
            tickColor: '#666',
            labels: {
                step: 2,
                rotation: 'auto',
                style: {
                    color: '#000000',
                }
            },
            title: {
                style: {
                    color: 'black',
                    fontWeight: 'normal'
                },
                text: data["yAxisTitle"]
            },
            plotBands: data["plotBands"]
        },
        tooltip: {
            formatter: function () {
                let s;
                s = '<b>' + this.series.name.slice(0, 40) + '</b> : ' + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.y * 100) / 100) + ' ' + data["yAxisTitle"];
                return s;
            }
        },
        series: [],
        credits: {enabled: false},
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        floating: false,
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom',
                        x: 0,
                        y: 0
                    },
                    yAxis: [{
                        labels: {
                            align: 'right',
                            x: 0,
                            y: -6
                        },
                        showLastLabel: false
                    }, {
                        labels: {
                            align: 'left',
                            x: 0,
                            y: -6
                        },
                        showLastLabel: false
                    }, {
                        visible: false
                    }]
                }
            }]
        },

    }
    //
    for (let i = 0; typeof data["test" + i] != 'undefined'; i++) {
        chartParam.series.push(data["test" + i][0]);
    }
    
    return chartParam;
}
/**
 * * Catégorie 1 le type Area
 * **/
export const scriptNoTempAreaCharts = (data) => {
    let chartParam = {
        chart: {
            //backgroundColor: 'Transparent',
            zoomType: 'x',
            type: 'area',
            backgroundColor: '#FFFFFF',
        },
        exporting: {
            enabled: false,
            buttons: {
                contextButton: {
                    menuItems:["viewFullscreen","separator","downloadCSV","downloadXLS","downloadJPEG"]
                }
            },
            sourceHeight: 720,
            sourceWidth: 1280,
            filename: 'export'
        },
        legend: {
            itemStyle: {
                color: '#000000',
                fontWeight:"600", 
                fontFamily:'"Source Sans Pro",sans-serif'
            },
        },
        title: {
            text: ' '
        },
        xAxis: {
            labels: {
                style: {
                    color: '#000000',
                }
            },
            categories: data["categories"]
        },
        yAxis: {
            title: {
                style: {
                    color: 'black',
                    fontWeight: 'normal'
                },
                text: data["yAxisTitle"]
            },
            labels: {
                style: {
                    color: '#000000',
                }
            },
            min: 0
            //max: 1500
        },

        tooltip: {
            formatter: function () {
                return '<b>' + this.series.name.slice(0, 40) + '</b><br/>' +
                    this.x + ': ' + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.y * 100) / 100) + ' ' + data["yAxisTitle"] + '<br/>';
                //'Total: '+ this.point.stackTotal;   //A voir pour autre
            }
        },
        plotOptions: {
            area: {
                //pointStart: 1940,
                marker: {
                    enabled: false,
                    symbol: 'circle',
                    radius: 2,
                    states: {
                        hover: {
                            enabled: true
                        }
                    }
                }
            }
        },
        series: [],
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        floating: false,
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom',
                        x: 0,
                        y: 0
                    },
                    yAxis: [{
                        labels: {
                            align: 'right',
                            x: 0,
                            y: -6
                        },
                        showLastLabel: false
                    }, {
                        labels: {
                            align: 'left',
                            x: 0,
                            y: -6
                        },
                        showLastLabel: false
                    }, {
                        visible: false
                    }]
                }
            }]
        },
        credits: {enabled: false},
    };
    for (let i = 0; typeof data["test" + i] != 'undefined'; i++) {
        chartParam.series.push(data["test" + i][0]);
    }
    return chartParam;
}
/**
 * * Catégorie 1 le type Column
 * **/
export const scriptNoTempColumnCharts = (data) => {
    let chartParam = {
        chart: {
            //backgroundColor: 'Transparent',
            zoomType: 'x',
            type: 'area',
            backgroundColor: '#FFFFFF',
        },
        exporting: {
            enabled: false,
            buttons: {
                contextButton: {
                    menuItems:["viewFullscreen","separator","downloadCSV","downloadXLS","downloadJPEG"]
                }
            },
            sourceHeight: 720,
            sourceWidth: 1280,
            filename: 'export'
        },
        legend: {
            itemStyle: {
                color: '#000000',
                fontWeight:"600", 
                fontFamily:'"Source Sans Pro",sans-serif'
            },
        },
        title: {
            text: ' '
        },
        xAxis: {
            labels: {
                style: {
                    color: '#000000',
                }
            },
            categories: data["categories"]
        },
        yAxis: {
            title: {
                style: {
                    color: 'black',
                    fontWeight: 'normal'
                },
                text: data["yAxisTitle"]
            },
            labels: {
                style: {
                    color: '#000000',
                }
            },
            min: 0
            //max: 1500
        },

        tooltip: {
            formatter: function () {
                return '<b>' + this.series.name.slice(0, 40) + '</b><br/>' +
                    this.x + ': ' + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.y * 100) / 100) + ' ' + data["yAxisTitle"] + '<br/>';
                //'Total: '+ this.point.stackTotal;   //A voir pour autre
            }
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                stacking: "normal",
                useUTC: false,
                animation: true
            }
        },
        series: [],
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        floating: false,
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom',
                        x: 0,
                        y: 0
                    },
                    yAxis: [{
                        labels: {
                            align: 'right',
                            x: 0,
                            y: -6
                        },
                        showLastLabel: false
                    }, {
                        labels: {
                            align: 'left',
                            x: 0,
                            y: -6
                        },
                        showLastLabel: false
                    }, {
                        visible: false
                    }]
                }
            }]
        },
        credits: {enabled: false},
    };


    for (let i = 0; typeof data["test" + i] != 'undefined'; i++) {
        chartParam.series.push(data["test" + i][0]);
    }
    console.log(chartParam);
    return chartParam;
}

